import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DataBaseProvider } from '../../providers/data-base/data-base';
import * as moment from 'moment';

@IonicPage()
@Component({
  selector: 'page-bill-preview',
  templateUrl: 'bill-preview.html',
})
export class BillPreviewPage {

  data: any;
  dataKey: string;
  previewMode: string;
  tenant: any;
  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public $db: DataBaseProvider) {
    this.dataKey = this.navParams.get('billKey');
    this.previewMode = this.navParams.get('mode');
    this.$db.getBillingInfo(this.dataKey).subscribe(billdata => {
      this.data = billdata;
      this.getTenantInfo();
      if (this.previewMode !== 'PREVIEW') {
        this.perfomPrintOperations();
      }
    })
  }

  getTenantInfo() {
    this.$db.getUserInfo(this.data.owner).subscribe(data => {
      this.tenant = data;
    })
  }

  ionViewDidLoad() {
    // init print once the data is loaded

  }

  perfomPrintOperations() {
    setTimeout(_ => window.print(), 300);
    // shutdown the print preview page
    setTimeout(_ => this.navCtrl.popToRoot(), 400);
  }

  convertTimeStampToDate(timeStamp) {
    return timeStamp ? moment.unix(timeStamp.seconds).format('DD MMM YYYY, hh:mm A') : '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/bill-preview/bill-preview.ts